import * as React from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/fr'; // <-- add
import Stack from '@mui/material/Stack';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

dayjs.extend(customParseFormat);
dayjs.locale('fr'); // <-- add

export default function DateTimePickerComponent({
  dateSelected,
  label,
  value,
  required = false,
  typeDate = 'date', // 'date' | 'datetime'
}) {
  // Accept both ISO (backend) and FR strings when parsing incoming value
  const parsedValue = value
    ? (typeDate === 'date'
        ? dayjs(value, ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true)
        : dayjs(value, ['YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm', 'DD-MM-YYYY HH:mm'], true))
    : null;

  const handleDateChange = (newValue) => {
    if (newValue && newValue.isValid()) {
      // Send normalized ISO-like string to backend
      const formatted =
        typeDate === 'date'
          ? newValue.format('YYYY-MM-DD')
          : newValue.format('YYYY-MM-DD HH:mm:ss');
      dateSelected?.(formatted);
    } else {
      dateSelected?.(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
      <Stack spacing={2} sx={{ width: '100%' }}>
        {typeDate === 'date' ? (
          <DatePicker
            size="small"
            label={label}
            value={parsedValue}
            onChange={handleDateChange}
            format="DD/MM/YYYY"           // <-- FR display
            slotProps={{
              textField: {
                required,
                fullWidth: true,
                sx: { 
                 
                  '& .MuiOutlinedInput-root': { 
                    
                    '& fieldset': { borderRadius: '12px' } 
                  },
                  '& .MuiInputLabel-root': {
                   
                  },
                 
                },
              },
              popper: { style: { zIndex: 99999999 } },
            }}
          />
        ) : (
          <DateTimePicker
            label={label}
            value={parsedValue}
            onChange={handleDateChange}
            format="DD/MM/YYYY HH:mm"    // <-- FR display (24h)
            ampm={false}                 // 24-hour clock
            slotProps={{
              textField: {
                required,
                fullWidth: true,
                sx: { 
                  fontSize: '14px',
                  '& .MuiOutlinedInput-root': { 
                    height: '55px',
                    '& fieldset': { borderRadius: '8px' } 
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: '14px',
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '12px 14px',
                    fontSize: '14px',
                  },
                },
              },
              popper: { style: { zIndex: 99999999 } },
            }}
          />
        )}
      </Stack>
    </LocalizationProvider>
  );
}
